import React, { useEffect, useMemo, useRef, useState } from 'react';

function formatNumber(n) {
  try {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);
  } catch {
    return String(n);
  }
}

export default function AnimatedCounter({
  value,
  durationMs = 1100,
  prefix = '',
  suffix = '',
}) {
  const prefersReducedMotion = useMemo(
    () => (typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches),
    [],
  );

  const raf = useRef(null);
  const [display, setDisplay] = useState(prefersReducedMotion ? value : 0);

  useEffect(() => {
    if (prefersReducedMotion) {
      setDisplay(value);
      return undefined;
    }

    const start = performance.now();
    const from = display;
    const to = value;

    const tick = (now) => {
      const t = Math.min(1, (now - start) / durationMs);
      const eased = 1 - (1 - t) ** 3;
      setDisplay(Math.round(from + (to - from) * eased));
      if (t < 1) raf.current = requestAnimationFrame(tick);
    };

    raf.current = requestAnimationFrame(tick);
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, durationMs, prefersReducedMotion]);

  return (
    <span>
      {prefix}
      {formatNumber(display)}
      {suffix}
    </span>
  );
}

